const validItemFilter = (item) => {
  if (!item.visible) {
    return false;
  }
  return item;
};

export const menuTransformer = (menu) => {
  const { categories = [] } = menu;
  // const filteredCategory = categories.filter(filterValidCategory);

  const newCategories = [];

  const filteredVisibleCategories = categories.filter(
    (category) => category.visible
  );

  // Iterating filtered visible categories
  filteredVisibleCategories.forEach((category) => {
    const { categories: subCategories } = category;
    const newSubCategories = [];
    const filteredVisibleCategories = subCategories.filter(
      (category) => category.visible
    );
    // Iterating sub-categories
    filteredVisibleCategories.forEach((subCategory) => {
      //Checking items
      const { items } = subCategory;
      const newItems = [];
      // Iterating items
      items.forEach((item) => {
        if (validItemFilter(item)) {
          newItems.push(item);
        }
      });

      // Checking SubCategory
      if (newItems.length) {
        newSubCategories.push({
          ...subCategory,
          items: newItems,
        });
      }
    });
    // Checking for Categories
    if (newSubCategories.length) {
      newCategories.push({
        ...category,
        categories: newSubCategories,
      });
    }
  });

  return { ...menu, categories: newCategories };
};
